var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"program-card",on:{"click":function($event){return _vm.$emit('click')}}},[_c('ImageLazy',{attrs:{"src":_vm.imgUrl,"alt":_vm.alt},on:{"error":(e) => _vm.setImageDefault(e, 'program-card')}}),_vm._v(" "),_c('h4',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }